export default __webpack_public_path__ + "static/brandon-regular-3f438b9c37c325db745b8951f7d446eb.woff2";